import React, { Fragment } from "react";
import SortUp from "../../icons/sortUp";
import SortDown from "../../icons/sortDown";
import Pagination from "../pagination";
import styles from "./style.module.css";

const Table = ({
  rows,
  columns,
  handleSort,
  handlePagination,
  loading,
  limitData,
  totalData,
  selectedPage,
  footerColumns,
}) => {
  return (
    <div className={styles.table_container}>
      <div className={styles.tc_table}>
        <div className={styles.tc_table_inner}>
          <table
            className={`${styles.table} ${rows.length === 0 || loading ? styles.table_empty : ""
              }`}
          >
            <thead>
              <tr>
                {columns.map((item, index) => {
                  return (
                    <Fragment key={index}>
                      <th style={{ minWidth: item.width }}>
                        <div
                          className={`${styles.table_header} ${item.sorting ? styles.table_header_sort : ""
                            } ${item.direction ? styles.table_header_sort_on : ""
                            }`}
                          onClick={() => {
                            item.sorting && handleSort(item.name, index);
                          }}
                        >
                          <div className={styles.table_header_text}>
                            {item.title}
                          </div>
                          {item.sorting && handleSort && (
                            <div className={styles.table_header_icon}>
                              {item.direction.length > 0 ? (
                                item.direction === "ASC" ? (
                                  <SortUp />
                                ) : (
                                  <SortDown />
                                )
                              ) : (
                                <Fragment>
                                  <SortUp />
                                  <SortDown />
                                </Fragment>
                              )}
                            </div>
                          )}
                        </div>
                      </th>
                    </Fragment>
                  );
                })}
              </tr>
            </thead>
            {loading ? (
              <Fragment>
                <tbody>
                  {Array.from(Array(25).keys()).map((item) => (
                    <tr key={item}>
                      {columns.map((colItem, colIndex) => {
                        return (
                          <td key={colIndex}>
                            <div className={styles.table_skeleton} />
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </Fragment>
            ) : (
              <tbody>
                {rows.length > 0 ? (
                  <Fragment>
                    {rows.map((rowItem, rowIndex) => {
                      return (
                        <tr key={rowIndex}>
                          {columns.map((colItem, colIndex) => {
                            return (
                              <td key={colIndex}>{rowItem[colItem.name]}</td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </Fragment>
                ) : (
                  <tr>
                    <td
                      className={styles.table_no_data}
                      colSpan={columns.length}
                    >
                      <div className={styles.table_no_data_text}>No Data</div>
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </table>
        </div>
        {footerColumns && footerColumns.length > 0 && (
          <div className={styles.tc_table_footer}>
            <div className={styles.tc_table_footer_inner}>
              {footerColumns.map((item, index) => {
                if (item.col) {
                  return (
                    <div key={index} className={styles.tc_table_footer_item}>
                      {item.col}
                    </div>
                  );
                } else {
                  return "";
                }
              })}
            </div>
          </div>
        )}
      </div>
      {totalData !== 0 && handlePagination && (
        <div className={styles.tc_bottom}>
          <div className={styles.tc_num}>Total: {totalData} Records</div>
          <Pagination
            totalPages={Math.ceil(totalData / limitData)}
            selectedPage={selectedPage}
            handlePagination={handlePagination}
          />
        </div>
      )}
    </div>
  );
};

export default Table;
